/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnpaidPaymentVo } from './UnpaidPaymentVo';
import {
    UnpaidPaymentVoFromJSON,
    UnpaidPaymentVoFromJSONTyped,
    UnpaidPaymentVoToJSON,
    UnpaidPaymentVoToJSONTyped,
} from './UnpaidPaymentVo';

/**
 * 
 * @export
 * @interface ResponseUnpaidPaymentVo
 */
export interface ResponseUnpaidPaymentVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseUnpaidPaymentVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseUnpaidPaymentVo
     */
    message?: string;
    /**
     * 
     * @type {UnpaidPaymentVo}
     * @memberof ResponseUnpaidPaymentVo
     */
    data?: UnpaidPaymentVo;
}

/**
 * Check if a given object implements the ResponseUnpaidPaymentVo interface.
 */
export function instanceOfResponseUnpaidPaymentVo(value: object): value is ResponseUnpaidPaymentVo {
    return true;
}

export function ResponseUnpaidPaymentVoFromJSON(json: any): ResponseUnpaidPaymentVo {
    return ResponseUnpaidPaymentVoFromJSONTyped(json, false);
}

export function ResponseUnpaidPaymentVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUnpaidPaymentVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : UnpaidPaymentVoFromJSON(json['data']),
    };
}

export function ResponseUnpaidPaymentVoToJSON(json: any): ResponseUnpaidPaymentVo {
    return ResponseUnpaidPaymentVoToJSONTyped(json, false);
}

export function ResponseUnpaidPaymentVoToJSONTyped(value?: ResponseUnpaidPaymentVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': UnpaidPaymentVoToJSON(value['data']),
    };
}

